import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-6-5.667v-3.5c.32 0 .595-.114.824-.342.228-.229.343-.503.343-.824 0-.321-.115-.596-.343-.824A1.123 1.123 0 0 0 6 10.5V7h11.667v9.333H6Zm4.375-7.583h2.268c.54 0 1 .189 1.378.567.378.378.567.837.567 1.377s-.19 1-.567 1.378a1.875 1.875 0 0 1-1.378.567h-.972v1.944h-1.296V8.75Zm1.296 2.593h1.037c.179 0 .331-.064.458-.19a.624.624 0 0 0 .19-.459.624.624 0 0 0-.19-.457.624.624 0 0 0-.458-.19h-1.037v1.296Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
